import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 23"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.087 5.826 9 .173 9.241 0 15 5.998 9.241 12 9 11.827l3.087-6.001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.75 13.5v-.75h-1.5v.75h1.5ZM2.048 17.588l.657-.36-.657.36ZM3.69 7.296l-.513-.548.513.548ZM17.25 13.5a7.75 7.75 0 0 1-1.627 4.752l1.185.92A9.25 9.25 0 0 0 18.75 13.5h-1.5Zm-1.627 4.752a7.75 7.75 0 0 1-4.2 2.755l.373 1.453a9.25 9.25 0 0 0 5.012-3.289l-1.185-.92Zm-4.2 2.755a7.75 7.75 0 0 1-5.006-.397l-.597 1.377a9.251 9.251 0 0 0 5.976.474l-.372-1.454Zm-5.006-.397a7.75 7.75 0 0 1-3.712-3.383l-1.315.722a9.25 9.25 0 0 0 4.43 4.038l.597-1.377Zm-3.712-3.383a7.75 7.75 0 0 1-.858-4.948l-1.481-.237A9.25 9.25 0 0 0 1.39 17.95l1.315-.722Zm-.858-4.948a7.75 7.75 0 0 1 2.356-4.436L3.177 6.748a9.25 9.25 0 0 0-2.811 5.294l1.48.237Zm2.356-4.436a7.75 7.75 0 0 1 4.58-2.06L8.645 4.29a9.25 9.25 0 0 0-5.468 2.458l1.026 1.095Zm4.58-2.06a7.75 7.75 0 0 1 4.882 1.181L14.47 5.7a9.25 9.25 0 0 0-5.826-1.41l.138 1.494Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }